import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { IonContent, NavParams } from '@ionic/angular';
import { Navigator } from 'src/app/services/routing/navigator';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { EMAIL_PATTERN, PASSWORD_PATTERN } from 'src/app/services/customFormValidators';
import { EventsService } from 'src/app/services/event/event.service';
import { GlobalErrorHandlerService } from 'src/app/services/global-errors/global-error-handler.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { RoutingService } from 'src/app/services/routing/routing.service';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss'],
})
export class PasswordResetComponent implements OnInit {

  @ViewChild(IonContent, { static: false }) content: IonContent;

  public passwordResetForm: FormGroup
  public confirmPassword: AbstractControl;
  public passwordGroup: AbstractControl
  public newPassword: AbstractControl;
  public username: AbstractControl;

  public error: GlobalErrorHandlerService = null;
  public successScreen: boolean = true;
  public urlToken: any;

  public showNewPassword: boolean;
  public showConfirmPassword: boolean;
  public tokenURL: string;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    public authenticationService: AuthenticationService,
    public events: EventsService,
    public navParams: NavParams,
    public navigator: Navigator,
    public successMessageService: SuccessMessageService,
    public utilsService: UtilsService,
    private routing: RoutingService,
  ) {
    this.successMessageService.clearMessage();
    //Fetch the Token from navParams logic
    let holdURL = this.navParams.get('tokenURL');
    console.log(holdURL)
    let getQueryString = holdURL.split("?")[1]
    let token = getQueryString.split('=')[1];
    this.tokenURL = token.split('#')[0];
    console.log(this.tokenURL)
    this.getToken(this.tokenURL);
  }

  ngOnInit(): void {

    //this.getToken();

    this.passwordResetForm = new FormGroup({
      username: new FormControl('', [Validators.required, Validators.pattern(EMAIL_PATTERN)]),
      passwordGroup: new FormGroup({
        newPassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.pattern(PASSWORD_PATTERN)]),
        confirmPassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.pattern(PASSWORD_PATTERN)]),
      }, this.passwordMatchValidator),
    });

    this.username = this.passwordResetForm.get('username');
    this.passwordGroup = this.passwordResetForm.get('passwordGroup');
    this.newPassword = this.passwordGroup.get('newPassword');
    this.confirmPassword = this.passwordGroup.get('confirmPassword');
  }

  private passwordMatchValidator(g: FormGroup) {
    return g.get('newPassword').value === g.get('confirmPassword').value ? null : { 'mismatch': true };
  }

  private getToken(data): any {
    /*this.activatedRoute.queryParams.subscribe((params) => {
      this.urlToken = params.token;
    }, error => {
        this.content.scrollToTop(10);
        this.error = error;
        error.setErrorMessage("token not received");
      }
  )*/
    if (data) {
      this.urlToken = data;
    } else {
      console.log('token not received');
      this.content.scrollToTop(10);
      //this.error = error;
      this.error.setErrorMessage("token not received");
    }
  }

  public onSubmit() {

    this.successMessageService.clearMessage();
    this.error = null;

    let passwordResetFormObj: any = this.passwordResetForm.value;
    passwordResetFormObj.token = this.urlToken;

    this.authenticationService.callResetPasswordByToken(passwordResetFormObj).subscribe((response: any) => {
      if (response && !!response.result) return this.successActions();
    }, error => {
      this.content.scrollToTop(10);
      this.error = error;
      error.setErrorMessage(" Password reset process Failed, Please try again using login or contact support.");
    });
  }

  private successActions(): any {
    this.successMessageService.setMessage("Password reset successfully, please login and continue as instructed. Thanks")
    this.successScreen = false;
    this.content.scrollToTop(10);
    this.showPasswordSuccessAlert()
    return setTimeout(() => this.onLogin(), 15 * 1000);
  }

  public showPasswordSuccessAlert(): any {
    const popoverComp = 'PopoverAlertComponent';

    let data: any = {
      content: "Password reset succesfully, please login and continue as instructed. Thanks",
    };

    return this.navigator.openPopover(popoverComp, data);
  }

  public onLogin(): any {
    this.events.publish("event:lobby:show");
    this.routing.defaultRoute();
    return this.navigator.navigateTo("LoginComponent");
  }

  onBack = () => {
    this.onLogin();
  }

  hideNewPassword(): void {
    this.showNewPassword = false;
  }

  unhideNewPassword(): void {
    this.showNewPassword = true;
  }
  hideConfirmPassword(): void {
    this.showConfirmPassword = false;
  }

  unhideConfirmPassword(): void {
    this.showConfirmPassword = true;
  }
}
